export enum LocalizationCodesEnum {
  En = 'en',
  Fr = 'fr',
}
